import _orderBy from 'lodash/orderBy'
import FactoryLevel from 'frontend/helpers/factoryLevel'
import { createFilterOption } from 'frontend/helpers/filterSelectorUtils'

const stateObj = {
  factoryLevels: [],
  disabled: false,
}

const gettersObj = {
  getFactoryLevels (state) {
    return state.factoryLevels
  },
  getIsFactoryLevelsDisabled (state) {
    return state.disabled
  },
  getPerimeterOptions: (state) => (factoryLevels=[], disabledPerimeters=[]) => {
    const perimeterOptions = []
    factoryLevels = FactoryLevel.getOnlyPatterns(factoryLevels.length > 0 ? factoryLevels : state.factoryLevels)
    
    factoryLevels.forEach((factoryLevel) => {
      perimeterOptions.push({ header: factoryLevel.name })
      const perimeters = _orderBy(factoryLevel.items, 'name', 'asc')
      perimeters.forEach(perimeter => {
        perimeterOptions.push(createFilterOption({
          value: perimeter.id,
          text: perimeter.name,
          group: factoryLevel.name,
          isDisabled: disabledPerimeters.includes(perimeter.id),
        }))
      })
    })
    return perimeterOptions
  },
  getPerimeterOptionsInCaller: (state, getters) => (caller) => {
    const factoryLevel = FactoryLevel.getFactoryLevelByCaller(caller)
    const options = getters.getPerimeterOptions([factoryLevel])
    return options
  },
  getPerimeterOptionsByCaller: () => (caller, filter) => {
    if (filter === undefined) {
      filter = () => true
    }
    let perimeterOptions = []
    const items = FactoryLevel.getPerimetersIdsTopLevel(caller)
    const factoryParents = FactoryLevel.getLowestFactoryParents(caller)
    const factoryTree = FactoryLevel.getFactoryTreeByLevelItems(items, factoryParents)
      .filter(level => level.items.length !== 0)
    factoryTree.forEach(level => {
      const tmpPerimeterOptions = level.items.filter(filter).map(perimeter => {
        return createFilterOption({
          value: perimeter.id,
          text: perimeter.name,
          group: level.name,
        })
      })
      if (tmpPerimeterOptions.length > 0) {
        perimeterOptions.push({ header: level.name })
        perimeterOptions = perimeterOptions.concat(tmpPerimeterOptions)
      }
    })
    return perimeterOptions
  },
}

const mutations = {
  setFactoryLevels (state, factoryLevels) {
    state.factoryLevels = factoryLevels
  },
  setFactoryLevelsDisabled (state, disabled) {
    state.disabled = disabled
  },
  addPerimeterInFactoryLevel (state, perimeter) {
    const factoryLevel = state.factoryLevels.find(factoryLevelData => factoryLevelData.id === perimeter.pattern)
    if (factoryLevel === null) return
    factoryLevel['items'].push({
      id: perimeter.id,
      name: perimeter.name,
      parent: perimeter.parent,
    })
  },
  updatePerimeterInFactoryLevel (state, perimeter) {
    const factoryLevel = state.factoryLevels.find(factoryLevelData => factoryLevelData.id === perimeter.pattern)
    if (factoryLevel === null) return
    const perimeterIndex = factoryLevel.items.findIndex(currentPerimeter => currentPerimeter.id === perimeter.id)
    if (perimeterIndex === -1) return
    if (perimeterIndex !== null) {
      factoryLevel.items.splice(perimeterIndex, 1, {
        id: perimeter.id,
        name: perimeter.name,
        parent: perimeter.parent,
      })
    }
  },
  deletePerimeterInFactoryLevel (state, perimeter) {
    const factoryLevels = state.factoryLevels.filter(factoryLevel => factoryLevel.type === FactoryLevel.PATTERN)
    factoryLevels.forEach(factoryLevel => {
      factoryLevel['items'] = factoryLevel['items']
        .filter(currentPerimeter => currentPerimeter.id !== perimeter.id)
        .filter(currentPerimeter => currentPerimeter.parent === null || currentPerimeter.parent !== perimeter.id)
    })
    FactoryLevel.resetSelections()
  },
}

const actions = {
}

export default {
  state: stateObj,
  getters: gettersObj,
  mutations,
  actions,
}
